// extracted by mini-css-extract-plugin
export default {"pnl-history":"PNLHistory_pnl-history__U3h69"};